import React, { Component } from 'react';
import { Row, Button, message, Divider, Icon, Input } from 'antd';
import './index.scss';

import logo0 from '../../assets/logo0.png';
import logo1 from '../../assets/logo1.png';
import logo2 from '../../assets/logo2.png';

class LoginSales extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            password: "",
            submit: {
                name: 0,
                password: 0
            },
            loading: false
        }
    }

    componentDidMount() {
        //注册键盘事件  
        document.onkeydown = (e) => {
            if (e.keyCode == 13 && window.location.hash === '#/login') {
                this.submit();
            }
        }
    }

    submit = () => {
        let { name, password, submit } = this.state;
        const that = this;
        let text = /^1[34578]\d{9}$|[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
        if (!name) {
            this.setState({
                submit: { ...submit, name: 1 }
            });
            message.error("请输入正确帐号！");
            return
        }

        if (!password) {
            this.setState({
                submit: { ...submit, password: 1 }
            });
            message.error("请输入密码！");
            return
        }
        this.setState({ loading: true });
        const url = '/auth/login'
        fetch(url, {
            method: 'post',
            credentials: 'include',
            headers: {
                "Content-type": "application/x-www-form-urlencoded; charset=UTF-8"
            },
            body: 'email=' + name + '&password=' + password
        })
            .then((response) => response.json())
            .then(function (data) {

                if (data && data.status === 1) {
                    sessionStorage.user = JSON.stringify(data.data);
                    message.success('登录成功');

                    window.location.href = '/';
                } else {
                    that.setState({ loading: false });
                    message.error(data.msg);
                    return;
                }
            }).catch(err => {
                that.setState({ loading: false });
                message.error("登录失败！");
                console.error(err)
            })
    }

    render() {
        return (
            <div className="sales_login">
                <Row className="login-img">
                    <div>
                        <img src={logo2} alt="" />
                    </div>
                    <div>
                        <img src={logo0} alt="" />
                    </div>
                    <div>
                        <img src={logo1} alt="" />
                    </div>
                </Row>
                <Row style={{ marginTop: "16vh", position: "relative" }} className="ant-form-item-control-wrapper">
                    <div className="login-divider">
                        <Divider style={{ color: "#fff" }}>登录</Divider>
                    </div>
                    <Input
                        type="text"
                        placeholder="请输入帐号"
                        value={this.state.name}
                        className="login_input"
                        prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)', fontSize: 18 }} />}
                        style={{ boxShadow: !this.state.submit.name ? "" : "0 0 4px 2px red" }}
                        onChange={(e) => {
                            if (e.target.value) {
                                this.setState({ submit: { ...this.state.submit, name: 0 } });
                            } else {
                                this.setState({ submit: { ...this.state.submit, name: 1 } });
                            }

                            this.setState({
                                name: e.target.value,
                            });
                        }}
                    />
                </Row>
                <Row style={{ marginTop: 20, position: "relative" }}>
                    <Input
                        type="password"
                        placeholder="请输入密码"
                        className="login_input"
                        value={this.state.password}
                        prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)', fontSize: 18 }} />}
                        style={{ boxShadow: !this.state.submit.password ? "" : "0 0 4px 2px red" }}
                        onChange={(e) => {
                            if (e.target.value) {
                                this.setState({ submit: { ...this.state.submit, password: 0 } });
                            } else {
                                this.setState({ submit: { ...this.state.submit, password: 1 } });
                            }

                            this.setState({
                                password: e.target.value,

                            });
                        }}
                    />
                </Row>
                <Button
                    type="primary"
                    onClick={this.submit}
                    loading={this.state.loading}
                    style={{ width: '420px', height: 50, marginTop: 40, borderRadius: '30px', maxWidth: '100%' }}
                >
                    登录
				</Button>
            </div>
        );
    }
}

export default LoginSales;



// WEBPACK FOOTER //
// ./src/components/login/index.js